/**
 * This will call all event handler functions passed to it in order.
 */
export function callAllEventHandlers(...fns) {
    return (event, ...args) => fns.forEach(fn => {
        fn && fn(event, ...args);
    });
}
//# sourceMappingURL=callAllEventHandlers.js.map